<template>
  <div class="app-root">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
html,
body,
#app,
.app-root {
  margin: 0;
  padding: 0;
  height: 100%;
  
  

}
/* 全局样式文件里写，不要 scoped */
.el-dialog {
  border-radius: 8px !important;
  overflow: hidden; 
}
</style>

